import { ProfileService } from './../../../../../shared/services/profile.service';
import { IProfile } from './../../../../../_models/account/IProfile';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service-book-list',
  templateUrl: './service-book-list.component.html'
})
export class ServiceBookListComponent implements OnInit {
  title: string = 'Service Book';
  skeleton: boolean = true;
  profile: IProfile;
  profileId;
  financialYearId;

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: true },
    { title: 'School/Places', key: 'SchoolId', isSortable: true },
    { title: 'Designation', key: 'DesignationId', isSortable: true },
    { title: 'From', key: 'DurationFrom', isSortable: true },
    { title: 'To', key: 'DurationTo', isSortable: true },
    { title: 'Posting Reason', key: 'TransferReason', isSortable: true },
    // { title: 'Transfer Category', key: 'Transfer Category', isSortable: true },
    { title: 'Deductible Leave/Absence(days)', key: 'TransferReason', isSortable: true },
    {}
  ];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private profileService: ProfileService) {
      this.profileId = this.route.snapshot.paramMap.get('profileId');
      this.financialYearId = this.route.snapshot.paramMap.get('financialYearId');
  }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.profileService.get(this.profileId).subscribe((response: IProfile) => {
      if (response) {
        this.profile = response;
      }
      else {
        this.toastrService.success('you must fill up profile first.');
        this.router.navigate(['/region/employees/view', this.profileId,this.financialYearId]);
      }
    }, (error) => console.log(error),
    () => this.skeleton = false);
  }
}
